// src/App.js
import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, useLocation, useNavigate } from "react-router-dom";
import { TabBar } from "antd-mobile";
import MainService from "./utils/mainservice";

import MyRouter from "./router/MyRouter";

import { setLocalLangFun, getAllStrFun, getSupportedLanguageKey, checkChannelChanged } from "./utils/util";
import { getClientAuthToken } from "./utils/authStorage";
import config from "./config/index.js";
import { applyThemeVars } from "./utils/applyTheme";
import { initPixelByChannel, captureRegisterState } from "./utils/pixelReport";
import "./App.css";
import ActiveHomeIcon from "./img/active-home.png";
import ActiveMyListIcon from "./img/active-my-list.png";
import ActiveProfileIcon from "./img/active-profile.png";
import DisActiveHomeIcon from "./img/disactive-home.png";
import DisActiveMyListIcon from "./img/disactive-my-list.png";
import DisActiveProfileIcon from "./img/disactive-profile.png";

const tabs = [
  {
    key: "home",
    title: "Home",
    icon: DisActiveHomeIcon,
    selectedIcon: ActiveHomeIcon,
  },
  {
    key: "mylist",
    title: "MyList",
    icon: DisActiveMyListIcon,
    selectedIcon: ActiveMyListIcon,
  },
  {
    key: "mine",
    title: "Peofile",
    icon: DisActiveProfileIcon,
    selectedIcon: ActiveProfileIcon,
  },
];

const TabBarComp = ({myLangGet, shouldRenderTabBar}) => {
  const navigate = useNavigate();
  const location = useLocation(); // Get the current location
  const [activeKey, setActiveKey] = React.useState("home");
  const [tabBarTitle, setTabBarTitle] = useState({home: "", mylist: "", mine: ""});

  // Update the active key based on the current path
  useEffect(() => {
    const path = location.pathname.split("/")[1]; // Get the path segment
    if (tabs.find((tab) => tab.key === path)) {
      setActiveKey(path);
    }
  }, [location.pathname]); // Update whenever path changes

  useEffect(() => {
    handleTabBarTitle();
  }, [myLangGet, location.pathname]);

  const handleTabBarTitle = () => {
    try {
      const obj = getAllStrFun();
      if (obj && obj.barhome && obj.barmylist && obj.barprofile) {
        setTabBarTitle({
          home: obj.barhome,
          mylist: obj.barmylist,
          mine: obj.barprofile
        });
      }
    } catch (error) {
      
    }
  };

  const handleTabChange = (key) => {
    if (activeKey !== key) {
      // 防止反复点击相同的 tab
      console.log(key, "handleTabChange....");
      setActiveKey(key);
      navigate(`/${key}`, { replace: true });
    } else {
      console.log("Clicked the same tab:", key); // Debugging log for the same tab click
    }
  };
  console.log('location.pathname----', location.pathname)

  return (
    <>
      {shouldRenderTabBar && (<div className={`tabbarcontainer tabbarcontainer-${config.CLASS_NAME_EXTENSION}`}>
        <TabBar activeKey={activeKey} onChange={handleTabChange} style={{ backgroundColor: "#212121" }} safeArea>
          {tabs.map((tab) => (
            <TabBar.Item
              title={<div className="tabtitle">{tabBarTitle[tab.key]}</div>}
              key={tab.key}
              icon={<div className="icon-img-box"><img src={activeKey === tab.key ? tab.selectedIcon : tab.icon} alt={tab.title} /></div>}
              selectedIcon={<div className="icon-img-box"><img src={tab.selectedIcon} alt={tab.title} /></div>}
              className={activeKey === tab.key ? "tab-active" : "tab-inactive"}
            />
          ))}
        </TabBar>
      </div>)}
    </>
  );
};

const App = () => {
  const [myTokenVal, setMyTokenVal] = useState("");
  const [myLangGet, setMyLangGet] = useState(0);

  useEffect(() => {
    applyThemeVars(config.THEME);
  }, []);

  /** 从 localStorage 同步 myTokenVal 到 React 状态；登录完成、静默刷新 token 后都会调用 */
  const syncTokenFromStorage = async (type='') => {
    try {
      const token = getClientAuthToken();
      if (token) {
        setMyTokenVal(token);
        return token;
      } else {
        if (type === 'onInit') {
          await handleLoginFun(false);
        } else {
          setMyTokenVal("");
          return "";
        }
      }
    } catch (e) {
      console.log("sync Token From Storage error", e);
    }
    setMyTokenVal("");
    return "";
  };

  // init 初始化登录 只在挂载的时候执行一次
  useEffect(() => {
    handleRemoveFun();
    // 存储 URL 及 channel 参数到本地存储
    const url = window.location.href; // 获取当前页面 URL
    localStorage.setItem("queryString", url); // 将 URL 存储到本地存储
    const urlParams = new URLSearchParams(window.location.search); // 获取 URL 查询参数
    const channel = urlParams.get("channel"); // 获取 'channel' 参数
    // 优先使用本地语言；本地没有时，回退到浏览器语言并写入本地
    const userLanguage = getSupportedLanguageKey();
    console.log("所有用户语言:", "---", userLanguage); // 打印所有用户语言
    setLocalLangFun(userLanguage, true);
    setMyLangGet(1);
    if (channel) {
      localStorage.setItem("channel", channel); // 将 channel 存储到本地存储
    }
    // 按渠道初始化像素：TikTok 渠道（536_tk 开头）加载 TikTok 像素，其余加载 Facebook 像素
    initPixelByChannel();
    // 捕获链接里的渠道 + registerdotnum（注册上报的指定集数，观看到该集时上报；本地存一个状态对象统一处理）
    captureRegisterState(channel, urlParams.get("registerdotnum"));
    // 登录
    handleLoginFun('onInit');
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // Update whenever path changes

  // request 拦截 -2 后静默登录成功时同步 user id
  useEffect(() => {
    window.addEventListener("auth-refreshed", syncTokenFromStorage);
    return () => window.removeEventListener("auth-refreshed", syncTokenFromStorage);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // 页面可见性变化时，播放页暂停/恢复
  useEffect(() => {
    const isWatchPage = () => {
      try {
        const p = window.location.pathname || "";
        return p === "/watch" || p.endsWith("/watch");
      } catch (e) {
        return false;
      }
    };

    const onVisible = () => {
      try {
        const urlParams = new URLSearchParams(window.location.search);
        let channel = urlParams.get("channel");
        // 渠道变化时按新渠道初始化像素并发 Pageview（initPixelByChannel 幂等，已加载的不重复加载）
        if (checkChannelChanged(channel)) {
          initPixelByChannel();
        }
      } catch (e) {}
      if (isWatchPage() && typeof window.__watchMinisOnShow === "function") {
        window.__watchMinisOnShow();
      }
    };

    const onHidden = () => {
      if (isWatchPage() && typeof window.__watchMinisOnHide === "function") {
        window.__watchMinisOnHide();
      }
    };

    const onVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        onVisible();
      } else {
        onHidden();
      }
    };

    document.addEventListener("visibilitychange", onVisibilityChange);
    window.addEventListener("pageshow", onVisible);
    window.addEventListener("pagehide", onHidden);

    return () => {
      document.removeEventListener("visibilitychange", onVisibilityChange);
      window.removeEventListener("pageshow", onVisible);
      window.removeEventListener("pagehide", onHidden);
    };
  }, []);

  const handleRemoveFun = () => {
    try {
      localStorage.removeItem("homebanner");
      sessionStorage.removeItem("cursearchkey");
      sessionStorage.removeItem("homelistvid");
      sessionStorage.removeItem("home_scroll_y");
      sessionStorage.removeItem("home_cp_last_close_ts");
      // 分销页隐藏入口 / 测试页写入 show_my_console_self=1 时，下次启动创建 vConsole
      if (
        localStorage.getItem("show_my_console_self") === "1" &&
        !window.show_console_front &&
        typeof window.VConsole === "function"
      ) {
        new window.VConsole();
        window.show_console_front = true;
        console.log("创建vconsole....~");
      }
    } catch (error) {
      
    }
    try {
      sessionStorage.setItem("my_first_in_app", String(Date.now()));
    } catch (error) {
      
    }
  };
  const handleLoginFun = async (fromval = '') => {
    try {
      await MainService.loginFunSilentV2(true);
    } catch (error) {}
    await syncTokenFromStorage(fromval);
  };
  return (
    <Router>
      <AppShell myTokenVal={myTokenVal} myLangGet={myLangGet} setMyLangGet={setMyLangGet} />
    </Router>
  );
};

/** Router 内布局：根据路由决定是否展示 TabBar，并给内容区留底 */
const AppShell = ({ myTokenVal, myLangGet, setMyLangGet }) => {
  const location = useLocation();
  const shouldRenderTabBar =
    location.pathname.includes("/home") ||
    location.pathname.includes("/mylist") ||
    location.pathname.includes("/mine") ||
    location.pathname === "/";

  return (
    <div className={`app-container${shouldRenderTabBar ? " has-tabbar" : ""}`}>
      <div className="content">
        <MyRouter myTokenVal={myTokenVal} myLangGet={myLangGet} setMyLangGet={setMyLangGet} />
      </div>
      <TabBarComp myLangGet={myLangGet} shouldRenderTabBar={shouldRenderTabBar} />
    </div>
  );
};

export default App;
